// extracted by mini-css-extract-plugin
module.exports = {"mark":"z_fn","mark_color_default":"z_fp","mark_color_green":"z_fq","mark_fill":"z_fr","mark_color_red":"z_fs","mark_color_blue":"z_ft","mark_bold":"z_fv"};